import { render, staticRenderFns } from "./IdButton.vue?vue&type=template&id=19f1f67b&scoped=true&"
import script from "./IdButton.vue?vue&type=script&lang=js&"
export * from "./IdButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f1f67b",
  null
  
)

export default component.exports